import LoggedOut from '@fiverr-private/header/entries/LoggedOut';

export default LoggedOut;
